import { render, staticRenderFns } from "./BlockFloatMessage.vue?vue&type=template&id=59a0c584&"
import script from "./BlockFloatMessage.vue?vue&type=script&lang=js&"
export * from "./BlockFloatMessage.vue?vue&type=script&lang=js&"
import style0 from "./BlockFloatMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports